import React from "react";
import { BriefcaseBusiness, Home, Map, MoreHorizontal, Trees } from "lucide-react";
type Tab = "home" | "plantations" | "mapExplorer" | "work" | "profile";
type BottomNavProps = {
  active: Tab;
  onChange: (tab: Tab) => void;
};
const items: {
  id: Tab;
  label: string;
  icon: typeof Home;
}[] = [{
  id: "home",
  label: "হোম",
  icon: Home
}, {
  id: "plantations",
  label: "বাগান",
  icon: Trees
}, {
  id: "mapExplorer",
  label: "ম্যাপ",
  icon: Map
}, {
  id: "work",
  label: "কাজ",
  icon: BriefcaseBusiness
}, {
  id: "profile",
  label: "আরও",
  icon: MoreHorizontal
}];
export function BottomNav({
  active,
  onChange
}: BottomNavProps) {
  return <nav aria-label="প্রধান নেভিগেশন" className="absolute inset-x-0 bottom-0 z-30 flex h-[74px] items-center justify-around border-t border-[#dce9df] bg-white px-2 pb-2 shadow-[0_-4px_16px_rgba(15,81,50,0.06)]" data-id="element-69" data-mp="2js9btxczdgzq">{items.map(({
      id,
      label,
      icon: Icon
    }) => <button key={id} onClick={() => onChange(id)} className={`flex min-w-[56px] flex-col items-center gap-1 rounded-xl px-2 py-1.5 text-[11px] font-semibold ${active === id ? "text-[#176B3A]" : "text-[#7a897e]"}`} data-id="element-70" data-mp="hxqtiqbqxvns"><span className={`flex h-7 w-10 items-center justify-center rounded-full ${active === id ? "bg-[#dbeee0]" : ""}`} data-id="element-71" data-mp="czmt3tmg9dhp"><Icon size={20} strokeWidth={active === id ? 2.5 : 1.9} data-id="element-72" data-mp="3v5hny8jc0t0h" /></span>{label}</button>)}</nav>;
}